import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

// Больше этого числа слайдов — включаем прокручиваемый Swiper.
// Столько же или меньше — просто табы со сменой картинки, без скролла.
const SCROLL_THRESHOLD = 5;
const DELAY = 5000;
const ACTIVE_CLASS = "section-features__item--active";
const SCROLL_CLASS = "section-features__items--scroll";

// Режим скролла (слайдов > 5): вертикальный Swiper, клик плавно скроллит к слайду.
const initScrollSlider = ($slider, $image) => {
    $slider.classList.add(SCROLL_CLASS);

    const updateImage = (swiper) => {
        const imageUrl = swiper.slides[swiper.activeIndex]?.dataset.imageUrl;

        if ($image && imageUrl) {
            $image.src = imageUrl;
        }
    };

    new Swiper($slider, {
        modules: [Autoplay],
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        watchSlidesProgress: true, // помечает видимые слайды классом swiper-slide-visible
        slideToClickedSlide: true,
        autoplay: {
            delay: DELAY,
            disableOnInteraction: false
        },
        on: {
            init: updateImage,
            slideChange: updateImage
        }
    });
};

// Режим табов (слайдов <= 5): без скролла, клик делает карточку активной
// и меняет картинку; активная переключается и по таймеру.
const initTabs = ($slider, $items, $image) => {
    let current = -1;
    let timer = null;

    const setActive = (index) => {
        const next = (index + $items.length) % $items.length;

        if (next === current) {
            return;
        }

        current = next;

        $items.forEach(($item, i) => {
            $item.classList.toggle(ACTIVE_CLASS, i === current);
        });

        const imageUrl = $items[current].dataset.imageUrl;

        if ($image && imageUrl) {
            $image.src = imageUrl;
        }
    };

    const stop = () => clearInterval(timer);

    const start = () => {
        stop();
        timer = setInterval(() => setActive(current + 1), DELAY);
    };

    $items.forEach(($item, index) => {
        $item.addEventListener("click", () => {
            setActive(index);
            start(); // перезапускаем таймер от момента клика
        });
    });

    $slider.addEventListener("mouseenter", stop);
    $slider.addEventListener("mouseleave", start);

    setActive(0);
    start();
};

export const featuresSlider = () => {
    const $slider = document.querySelector(".section-features__items");

    if (!$slider) {
        return;
    }

    const $items = Array.from($slider.querySelectorAll(".section-features__item"));
    const $image = document.querySelector(".section-features__image img");

    if (!$items.length) {
        return;
    }

    if ($items.length > SCROLL_THRESHOLD) {
        initScrollSlider($slider, $image);
    } else {
        initTabs($slider, $items, $image);
    }
};
